import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Text } from '@/components/ui/text';
import { type FC } from 'react';

export const FullTextScreeningWarningModal: FC<{
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  isLoading: boolean;
  onConfirm: () => void;
}> = ({ isOpen, onOpenChange, isLoading, onConfirm }) => {
  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle className="pr-1">Are you sure?</DialogTitle>
        </DialogHeader>
        <Text>
          This will reinitialize your extracted data. Export your extraction
          table first if needed.
        </Text>
        <DialogFooter>
          <DialogClose asChild>
            <Button variant="outline">Cancel</Button>
          </DialogClose>
          <Button variant="destructive" onClick={onConfirm} loading={isLoading}>
            Yes, proceed to analysis
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
